import {
  getSessionStorageItem,
  setSessionStorageItem,
  SESSION_STORAGE_KEYS,
} from '@chegg-wt/core/utils/sessionStorage'
import { useRouter } from 'next/router'
import { trackWithoutThrow } from '@chegg-wt/core/utils/errors'

export const sessionStorageParamsKey = SESSION_STORAGE_KEYS.queryStringQAParams

export const sessionTimeoutKey = 'session-timeout'
export const exitIntentTimeoutKey = 'exit-intent-timeout'
export const paramKeys = [sessionTimeoutKey, exitIntentTimeoutKey]

interface QueryStringQAParams {
  [sessionTimeoutKey]?: string
  [exitIntentTimeoutKey]?: string
}

export const intOrUndefined = (numStr: string) => {
  const parsed = parseInt(numStr, 10)
  return Number.isNaN(parsed) ? undefined : parsed
}

export const useQueryStringQAParams = () => {
  const { query: urlParams } = useRouter()
  try {
    const storedParams: QueryStringQAParams =
      JSON.parse(getSessionStorageItem(sessionStorageParamsKey)) ?? {}

    paramKeys.forEach((paramKey) => {
      if (urlParams[paramKey]) storedParams[paramKey] = urlParams[paramKey]
    })

    setSessionStorageItem(sessionStorageParamsKey, JSON.stringify(storedParams))

    return storedParams
  } catch (e) {
    trackWithoutThrow(e)
    setSessionStorageItem(sessionStorageParamsKey, JSON.stringify({}))
    return {}
  }
}

export default useQueryStringQAParams
